import { get } from "./aws-amplify";

export async function getEnvironment() {
  const response = await get("EnvironmentsAPI", "/get-environment").response;
  const env = await response.body.text();
  return env;
}
